






import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class VIconNext extends Vue {
  @Prop() alt?: string;
  @Prop({ default: () => false }) disabled?: boolean;

  get classCss(): string {
    return "icon-next" + (this.disabled ? " disabled" : "");
  }

  handleEvent() {
    if (!this.disabled) {
      this.$emit("click");
    }
  }
}
